
export const checkIfJobTilesHaveProfile = () => {
    const jobsWidget = document.querySelectorAll(".jobs-carousel");

    if (!jobsWidget) return;

    jobsWidget.forEach((widget) => {
        const hasProfile = widget.querySelector(
            ".attrax-vacancy-tile__author-image-link"
        );

        if (hasProfile) {
            widget.classList.add("has-profile");
        }
    });
};

export const cloneHeading = () => {
    const jobsWidget = document.querySelectorAll(".jobs-carousel");

    jobsWidget.forEach((widget) => {
        const heading = widget.querySelector(
            ".attrax-list-widget__tab-heading"
        );

        if (heading) {
            const clonedHeading = heading.cloneNode(true);
            const list = widget.querySelector(".attrax-list-widget__list");
            list?.prepend(clonedHeading);
        }
    });
}

export const makePaginationAccessible = () => {
    const pagination = document.querySelectorAll('.attrax-pagination__pagination ul');

    if (!pagination.length) return;

    pagination.forEach((paginationElement) => {
        const addSrOnlyLabel = (selector: string, labelKey: string) => {
            const element = paginationElement.querySelector(selector);
            if (element) {
                const span = document.createElement('span');
                span.className = 'sr-only';
                span.textContent = labelKey;
                element.appendChild(span);
            }
        };

        addSrOnlyLabel('.attrax-pagination__next a', '{{js.pagination.next.page.hidden-label}}');
        addSrOnlyLabel('.attrax-pagination__prev a', '{{js.pagination.prev.page.hidden-label}}');
        addSrOnlyLabel('.attrax-pagination__results-first a', '{{js.pagination.first.page.hidden-label}}');
        addSrOnlyLabel('.attrax-pagination__last a', '{{js.pagination.last.page.hidden-label}}');
    });
}
